<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
    name: "IconCar1"
})
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="59" height="20">
        <path
            d="M15.8 14c-1.5 0-2.7 1-2.9 2.4 0 .2-.1.4-.1.6 0 .2 0 .4.1.6.3 1.4 1.5 2.4 2.9 2.4 1.2 0 2.3-.8 2.8-1.8.2-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2-.5-1-1.5-1.8-2.8-1.8"/>
        <circle cx="49.7" cy="17" r="3"/>
        <path
            d="M58.8 16s.2-8.1-.1-10c-.4-1.9-3-6-3-6H46l-1 11.3-1-.3V2v.2V2l-1 1v5H0v5h4v2h7.8s.3-2 4-2c3.6 0 4 2 4 2h14l1 2h11.1c0-.2.2-.6.2-1.2 0-.1 0-.2.1-.4 0-.1.1-.2.1-.4v-.1c.1-.1.1-.2.2-.3 0 0 0-.1.1-.1.1-.1.1-.2.2-.3l.1-.1c.1-.1.1-.2.2-.2l.1-.1c.1-.1.2-.1.3-.2.1 0 .1-.1.2-.1.1-.1.2-.1.3-.2.1 0 .2-.1.2-.1.1 0 .2-.1.3-.1.1 0 .2 0 .3-.1.1 0 .2 0 .3-.1h.8c3.2 0 3.4 3.7 4.8 4h.4c.3 0 .6-.1 1-.2.6-.1 1.1-.3 1.6-.4.6-.1 1.1-.3 1.1-.3"/>
    </svg>
</template>

<style scoped lang="scss">

</style>
